import { useEffect, useState } from 'react'
import { SSubtleInput } from './SubtleInput.styled'
export const SubtleInput = ({
  value,
  onSubmit,
  className,
}: {
  value?: string
  onSubmit?: (val?: string) => void
  className?: string
}) => {
  const [newValue, setNewValue] = useState(value)
  useEffect(() => {
    setNewValue(value)
  }, [setNewValue, value])

  return (
    <SSubtleInput
      className={className}
      value={newValue}
      onChange={(e) => setNewValue(e.target.value)}
      onBlur={() => onSubmit?.(newValue)}
      onKeyDown={(e) => e.key === 'Enter' && onSubmit?.(newValue)}
    />
  )
}
